import {
  put
} from 'redux-saga/effects';
import axios from '../../axios-local-api';
import * as actions from '../actions';
import packageJson from '../../../package.json';


export function* initDnsSaga(action) {
  const rMac = yield sessionStorage.getItem('mac');
  const token = yield sessionStorage.getItem('token');
  const sessionToken = yield sessionStorage.getItem('sessionToken');
  if (sessionToken) {
  yield put(actions.initDnsStart());
  let response = {};

  try {
        response = yield axios.post(
          '/dns',
          { rMac:rMac,
            bToken: token,
            sessionToken:sessionToken }
        ).then(res=>{
          var info = JSON.parse(res.data)
          return JSON.parse(info.dns)

        })

        yield (put(actions.setDns(response)));

  } catch (error) {
    yield put(actions.fetchDnsFailed());
  }

} else {
  // console.log('NO TOKEN')
 }
}

export function* changeDnsSaga(action) {
  const rMac = yield sessionStorage.getItem('mac');
  const token = yield sessionStorage.getItem('token');
  const accountNumber = yield sessionStorage.getItem('accountNumber');
  const eventName = 'DNS';
  const eventType = 'DNS Server - Default Success';
  const divId = yield sessionStorage.getItem('divId');
  const user = yield sessionStorage.getItem('userId');
  const sessionToken = yield sessionStorage.getItem('sessionToken');
  if (sessionToken) {
  try {
    let response = {};
        response = yield axios.post(
          '/dnsChange',
          { rMac:rMac,
          bToken: token,
          primaryDns:action.primaryDns,
          secondaryDns:action.secondaryDns,
          enabled:action.enabled,
          accountNumber: accountNumber,
          eventName: eventName,
          eventType: eventType,
          divId: divId,
          user: user,
          sessionToken:sessionToken },
          {
            validateStatus: false
          }
        );
        if(response.data.status === 200){
          yield put(actions.initDns(action));
          yield put(actions.changeDnsSuccess());
        } else {
          // console.log('FAILED DNS');
          yield put(actions.changeDnsFailed(response.status));
        }


  } catch (error) {
    // console.error('THERES CHANGE DNS ERROR', error)
    yield put(actions.changeDnsFailed());
  }
} else {
  // console.log('NO TOKEN')
  yield put(actions.changeDnsFailed());

 }

}
export function* defaultDnsSaga(action) {
  const rMac = yield sessionStorage.getItem('mac');
  const token = yield sessionStorage.getItem('token');
  const sessionToken = yield sessionStorage.getItem('sessionToken');
  if (sessionToken) {
  try {
    let response = {};

        response = yield axios.post(
          '/dnsChange',
          { rMac:rMac,
          bToken: token,
          sessionToken:sessionToken }
        )
        yield put(actions.initDns(action));
        yield put(actions.changeDnsSuccess());

  } catch (error) {
    // console.error('DEFAULT DNS ERROR', error)
    yield put(actions.changeDnsFailed());
  }
} else {
  // console.log('NO TOKEN')
  yield put(actions.changeDnsFailed());

 }

}



